﻿window.dataLayer = window.dataLayer || [];

(function ($, document, dataLayer) {
    function FetchContainer($item) {
        return $item
            .parents('.js-product-listing-container');
    }

    function FetchProductListing($item) {
        return FetchContainer($item)
                .find('.js-product-listing');
    }

    function FetchCurrentOptionsControl($item) {
        return FetchContainer($item)
            .find('.js-product-listing-options input[type=hidden]')
        ;
    }
    function ParseOptions($optionsControl) {
        return JSON.parse($optionsControl.val());
    }

    function SetLoading($productListing) {
        FetchContainer($productListing).append('<div class="product-listing--loading"></div>');
    }

    function RemoveLoading($productListing) {
        FetchContainer($productListing).find('.product-listing--loading').remove();
    }

    function PersistViaUrl($productListing) {
        return $productListing.data('products-persist') == "True";
    }

    function UpdateProductListing($productListing, $optionsControl, options, fallbackUrl, updateUrl) {
        options.OriginalQuery = options.OriginalQuery || _.trim(GetQuerystringParameter('searchtext'));
        SetLoading($productListing);
        $.ajax({
            url: '/api/products/listing',
            data: JSON.stringify(options),
            method: 'POST',
            contentType: "application/json"
        }).done(function (result) {
            $optionsControl.val(JSON.stringify(result.CurrentOptions));
            $productListing.html(result.ListingControl);
            window.SetupProductCarousel($('[data-product-carousel]', $productListing));
            RemoveLoading($productListing);
            $(document).trigger('Ellipsis.Page_OnRefresh');
            $(document).foundation('equalizer', 'reflow');
            document.ReinitializeTippy();
            if (History.enabled && updateUrl) {
                window.urlPushed = true;
                History.pushState(null, document.title, result.PersistentUrl);
            }
            Crafted.Utilities.InitializePriceSlider();
        }).error(function (result) {
            if (updateUrl) {
                window.location.href = fallbackUrl;
            } else {
                window.location.reload(true);
            }
        });
    }

    $(document).ready(function () {

        $('.producers-filter [data-alpha-list]').first().addClass('selected');

    });
    $(document).on('click', '.producers-filter .button', function (e) {
        e.preventDefault();
        var producerCodes = [];
        $('.producers-filter [data-producer-filter]:checked').each(function (i, n) {
            producerCodes.push($(this).data('producer-filter'));
        });
        var producersFilter;
        if (producerCodes.length == 1) {
            producersFilter = 'producer:' + producerCodes[0];
        }
        else if (producerCodes.length) {
            producersFilter = 'producer:(' + _.join(producerCodes, ",") + ')';
        }
        else {
            producersFilter = '';
        }
        var url = $(this).data('link-filter');
        var producersQueryString = _.trim(GetQuerystringParameter('filter', url).replace('{{producers}}', producersFilter));
        if (producersQueryString.length) {
            window.location.href = AddParameter(url, 'filter', producersQueryString);
        } else {
            window.location.href = RemoveParameter(url, 'filter');
        }
    });

    $(document).on('click', '.js-product-listing-container [data-filter]', function (e) {
        e.preventDefault();
        var $item = $(this);
        var filter = $item.data('filter');

        var $productListing = FetchProductListing($item);
        var $optionsControl = FetchCurrentOptionsControl($item);

        var options = ParseOptions($optionsControl);
        options.OriginalQuery = $item.data('original-query');
        options.CurrentFilter = filter;
        options.IsPageUpdate = false;

        UpdateProductListing(
            $productListing,
            $optionsControl,
            options,
            '',
            PersistViaUrl($productListing)
        );
    });

    $(document).on('click', '.js-product-listing-container .js-products-pricing', function (e) {
        e.preventDefault();
        var $item = $(this);
        var pricing = $(this).find('a').data('option');
        var fallbackUrl = $(this).find('a').attr('href');

        var $productListing = FetchProductListing($item);
        var $optionsControl = FetchCurrentOptionsControl($item);

        var options = ParseOptions($optionsControl);
        options.CurrentPricingView = pricing;
        options.IsPageUpdate = false;

        UpdateProductListing(
            $productListing,
            $optionsControl,
            options,
            fallbackUrl,
            PersistViaUrl($productListing)
        );
    });

    $(document).on('click', '.js-products-listview', function (e) {
        e.preventDefault();
        var $item = $(this);
        var listview = $(this).find('a').data('option');
        var fallbackUrl = $(this).find('a').attr('href');

        var $productListing = FetchProductListing($item);
        var $optionsControl = FetchCurrentOptionsControl($item);

        var options = ParseOptions($optionsControl);
        options.CurrentListView = listview;
        options.IsPageUpdate = false;

        UpdateProductListing(
            $productListing,
            $optionsControl,
            options,
            fallbackUrl,
            PersistViaUrl($productListing)
        );
    });

    $(document).on('click', '.js-products-stock', function (e) {
        e.preventDefault();
        var $item = $(this);
        var stockview = $(this).find('a').data('option');
        var fallbackUrl = $(this).find('a').attr('href');

        var $productListing = FetchProductListing($item);
        var $optionsControl = FetchCurrentOptionsControl($item);

        var options = ParseOptions($optionsControl);
        options.CurrentStockView = stockview;
        options.IsPageUpdate = false;

        UpdateProductListing(
            $productListing,
            $optionsControl,
            options,
            fallbackUrl,
            PersistViaUrl($productListing)
        );
    });

    $(document).on('change', '.js-products-sort', function (e) {
        e.preventDefault();
        var $item = $(this);
        var sort = $(this).find(':selected').data('sort');
        var fallbackUrl = $(this).find(':selected').val();

        var $productListing = FetchProductListing($item);
        var $optionsControl = FetchCurrentOptionsControl($item);

        var options = ParseOptions($optionsControl);
        options.CurrentSort = sort;
        options.IsPageUpdate = false;

        UpdateProductListing(
            $productListing,
            $optionsControl,
            options,
            fallbackUrl,
            PersistViaUrl($productListing)
        );
    });

    $(document).on('click', '.js-products-page', function (e) {
        e.preventDefault();
        var $item = $(this);
        var newPage = $item.data('page') - 0;
        var fallbackUrl = $item.attr('href');

        var $productListing = FetchProductListing($item);
        var $optionsControl = FetchCurrentOptionsControl($item);

        var options = ParseOptions($optionsControl);
        options.CurrentPage = newPage;
        options.IsPageUpdate = true;

        UpdateProductListing(
            $productListing,
            $optionsControl,
            options,
            fallbackUrl,
            PersistViaUrl($productListing)
        );
        if ($item.hasClass('js-products-page-bottom')) {
            Crafted.Utilities.ScrollToElement($('#product-list'));
        }
    });

    function GetQuerystringParameter(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    History.Adapter.bind(window, 'statechange', function () {
      var $productListing = $('.js-product-listing').not('[data-disable-statechange="true"]');
        if ($productListing.length && !window.urlPushed) {
            var $optionsControl = FetchCurrentOptionsControl($productListing);
            var options = ParseOptions($optionsControl);

            options.CurrentPage = GetQuerystringParameter('page');

            options.CurrentSort = GetQuerystringParameter('sort');

            options.CurrentListView = GetQuerystringParameter('view');

            options.CurrentPricingView = GetQuerystringParameter('price');

            options.IsPageUpdate = true;

            fallbackUrl = window.location.href;

            UpdateProductListing(
                $productListing,
                $optionsControl,
                options,
                fallbackUrl,
                false
            );
        }
        window.urlPushed = false;
    });

    function FindPriceFrom($item) {
        return FetchContainer($item)
                .find('.js-price-from');
    }

    function FindPriceTo($item) {
        return FetchContainer($item)
                .find('.js-price-to');
    }

    function AddParameter(url, key, value) {
        if (!url) url = window.location.href;
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
            hash;

        if (re.test(url)) {
            if (typeof value !== 'undefined' && value !== null)
                return url.replace(re, '$1' + key + "=" + value + '$2$3');
            else {
                hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
        }
        else {
            if (typeof value !== 'undefined' && value !== null) {
                var separator = url.indexOf('?') !== -1 ? '&' : '?';
                hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
            else
                return url;
        }
    }

    function RemoveParameter(url, parameter) {
        //prefer to use l.search if you have a location/link object
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url = urlparts[0] + '?' + pars.join('&');
            return url;
        } else {
            return url;
        }
    }

    $(document).on('click', '.js-products-price', function (e) {
        e.preventDefault();
        var $button = $(this);
        var priceFrom = (FindPriceFrom($button).val() || 0) - 0;
        if (priceFrom < 0) {
            priceFrom = 0;
        }
        var priceTo = (FindPriceTo($button).val() || 500);
        if (priceTo == '500+') {
            priceTo = 500;
        }

        priceTo = priceTo - 0;

        if (priceTo < 0 || priceTo > 500) {
            priceTo = 500;
        }

        var fallbackUrl = window.location.href;
        if (priceFrom != 0) {
            fallbackUrl = AddParameter(fallbackUrl, 'minprice', priceFrom);
        } else {
            fallbackUrl = RemoveParameter(fallbackUrl, 'minprice');
        }

        if (priceTo != 500) {
            fallbackUrl = AddParameter(fallbackUrl, 'maxprice', priceTo);
        } else {
            fallbackUrl = RemoveParameter(fallbackUrl, 'maxprice');
        }

        var $productListing = FetchProductListing($button);
        var $optionsControl = FetchCurrentOptionsControl($button);

        var options = ParseOptions($optionsControl);
        options.MinPrice = priceFrom == 0 ? null : priceFrom;
        options.MaxPrice = priceTo == 500 ? null : priceTo;
        options.IsPageUpdate = false;

        UpdateProductListing(
            $productListing,
            $optionsControl,
            options,
            fallbackUrl,
            PersistViaUrl($productListing)
        );
        Crafted.Utilities.ScrollToElement($('#product-list'));
    });

})(jQuery, document, dataLayer);